const { registerBlockType } = wp.blocks;

import attributes from './attributes';
import Edit from './edit';
import Save from './save';

registerBlockType('app/advantages', {
  title: 'Mais vantagens para quem assina',
  description: 'Serviços Digitais inclusos, perfeitos para você curtir online',
  icon: 'admin-site',
  category: 'design',
  attributes,
  supports: {
    align: ['full'],
  },
  edit: (props) => <Edit {...props} />,
  save: (props) => <Save {...props} />,
});
